import React from 'react'
import styles from "./Footer.module.css"
import Logo from "../../assets/Logo.jpg"
import { NavLink, useLocation } from 'react-router-dom'

function Footer(props) {
    const location = useLocation()
    return (
        <>

            <div className={`${styles.navbar} ${props.scrol > 99.9 && !props.home ? styles.newafooter : ""}`}>
                <div className={styles.navLogo}>
                    <img src={Logo} alt="" />
                </div>
                <div className={styles.navItem}>
                    <ul >
                        <li  ><NavLink to='/why-us' className={location.pathname === '/why-us' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>WHY US</NavLink></li>
                        <li ><NavLink to='/about' className={location.pathname === '/about' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>ABOUT US</NavLink></li>
                        <li><NavLink to='/approaches' className={location.pathname === '/approaches' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>APPROACH</NavLink></li>
                        <li><NavLink to='/service-work' className={location.pathname === '/service-work' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>SERVICES</NavLink></li>
                        <li><a target='_blank'  href='https://www.canva.com/design/DAFiTsBqbJ4/ObTRtfVcovm9IUHIhmo8HQ/view?utm_content=DAFiTsBqbJ4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink' className={location.pathname === '/portfolio' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>PORTFOLIO</a></li>
                        <li><NavLink to='/contact' className={location.pathname === '/contact' ? styles.activeTab : ""}  style={{ color: "#066263" }}>CONTACT</NavLink></li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default Footer